var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasErrors
    ? _c(
        "div",
        { staticClass: "validation-errors" },
        [
          _vm.expanded
            ? _c(
                "div",
                { staticClass: "validation-errors__list" },
                _vm._l(_vm.errors, function(message, index) {
                  return _c(
                    "BaseAlert",
                    {
                      key: "erro-" + index,
                      staticClass: "validation-errors__item",
                      attrs: { icon: _vm.icon, "icon-color": _vm.iconColor },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "button",
                            fn: function() {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "validation-errors__actions" },
                                  [
                                    _vm._t("action", null, { index: index }),
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function(ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    "span",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          staticClass:
                                                            "validation-errors__collapse"
                                                        },
                                                        "span",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _c("ActionButton", {
                                                        staticClass:
                                                          "validation-errors__arrow validation-errors__arrow--collapse",
                                                        attrs: {
                                                          "icon-only": "",
                                                          small: "",
                                                          "icon-color": "dark",
                                                          "icon-name":
                                                            "arrow-down-new-ux"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.collapseTo(
                                                              index
                                                            )
                                                          }
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      },
                                      [
                                        _c("span", [
                                          _vm._v("Recolher os alertas")
                                        ])
                                      ]
                                    )
                                  ],
                                  2
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "validation-errors__message",
                          class: {
                            "validation-errors__message--clickable":
                              _vm.isMessageClickable
                          },
                          on: {
                            click: function($event) {
                              return _vm.selectMessage(index)
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(message) + " ")]
                      )
                    ]
                  )
                }),
                1
              )
            : _c(
                "BaseAlert",
                {
                  attrs: { icon: _vm.icon, "icon-color": _vm.iconColor },
                  scopedSlots: _vm._u(
                    [
                      _vm.hasMultiple || _vm.$scopedSlots.action
                        ? {
                            key: "button",
                            fn: function() {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "validation-errors__actions" },
                                  [
                                    _vm._t("action", null, {
                                      index: _vm.currentIndex
                                    }),
                                    _vm.hasMultiple
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "validation-errors__nav"
                                          },
                                          [
                                            _c(
                                              "v-tooltip",
                                              {
                                                attrs: { top: "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function(ref) {
                                                        var on = ref.on
                                                        var attrs = ref.attrs
                                                        return [
                                                          _c(
                                                            "button",
                                                            _vm._g(
                                                              _vm._b(
                                                                {
                                                                  staticClass:
                                                                    "validation-errors__count",
                                                                  attrs: {
                                                                    type:
                                                                      "button"
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      _vm.expand
                                                                  }
                                                                },
                                                                "button",
                                                                attrs,
                                                                false
                                                              ),
                                                              on
                                                            ),
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.counterLabel
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  972604421
                                                )
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v("Ver todos os alertas")
                                                ])
                                              ]
                                            ),
                                            _c("span", {
                                              staticClass:
                                                "validation-errors__divider"
                                            }),
                                            _c("ActionButton", {
                                              staticClass:
                                                "validation-errors__arrow validation-errors__arrow--prev",
                                              attrs: {
                                                "icon-only": "",
                                                small: "",
                                                "icon-color": "dark",
                                                "icon-name":
                                                  "arrow-down-new-ux",
                                                label: "Anterior",
                                                disabled: _vm.isFirst
                                              },
                                              on: { click: _vm.prev }
                                            }),
                                            _c("ActionButton", {
                                              staticClass:
                                                "validation-errors__arrow validation-errors__arrow--next",
                                              attrs: {
                                                "icon-only": "",
                                                small: "",
                                                "icon-color": "dark",
                                                "icon-name":
                                                  "arrow-down-new-ux",
                                                label: "Próximo",
                                                disabled: _vm.isLast
                                              },
                                              on: { click: _vm.next }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  2
                                )
                              ]
                            },
                            proxy: true
                          }
                        : null
                    ],
                    null,
                    true
                  )
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "validation-errors__message",
                      class: {
                        "validation-errors__message--clickable":
                          _vm.isMessageClickable
                      },
                      on: {
                        click: function($event) {
                          return _vm.selectMessage(_vm.currentIndex)
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.currentMessage) + " ")]
                  )
                ]
              )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }